import { EditorServiceModels } from '@editor/client-rest-api';
import getStore from '../store/store';

/**
 * We want to return the current value for the given critique from the view state.
 * This means we should return the overridden value (if present), or the default value
 * if it is not overridden
 */
export default function getViewStateValueForCritique(id: string): number {
    const store = getStore();
    const defaultOptionsUI = store.defaultOptionsUI;
    const overriddenOptions = store.settingsDialogViewState.overriddenOptions;

    if (defaultOptionsUI?.has(id)) {
        const definition = defaultOptionsUI.get(id);
        if (!definition) {
            return 0;
        }

        if (overriddenOptions?.has(id)) {
            return getValueFromCritiqueTypeOption(
                definition.critiqueTypeInfo,
                overriddenOptions.get(id)
            );
        } else {
            return definition.critiqueTypeInfo.defaultCritiqueValue;
        }
    }

    return 0;
}

/**
 * Helper function to translate a value from the overridden value (the CritiqueTypeOption) to the
 * number value expected from the definition (CritiqueTypeInfo)
 */
function getValueFromCritiqueTypeOption(
    critiqueTypeInfo: EditorServiceModels.CritiqueTypeInfo,
    critiqueTypeOption: EditorServiceModels.CritiqueTypeOption | undefined
): number {
    if (!critiqueTypeOption) {
        return 0;
    }

    if (critiqueTypeInfo.isBinaryCritiqueType) {
        return critiqueTypeOption.value === '1' ? 1 : 0;
    } else if (critiqueTypeInfo.critiqueTypeValues) {
        return parseInt(critiqueTypeOption.value);
    }

    return 0;
}
